import { DiscountGroupType } from "@redotech/redo-model/discount";
import { DiscountCategory } from "@redotech/redo-model/discount/discount-db-parser";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { redoDiscountSchema } from "./discount-schemas";

export const getDiscountsByTeam = {
  name: "getDiscountsByTeam" as const,
  input: z.object({
    groupType: createEnum(DiscountGroupType).optional(),
    category: createEnum(DiscountCategory).optional(),
  }),
  output: z.array(redoDiscountSchema),
};
